import { render, staticRenderFns } from "./OpenaiWebSearch.vue?vue&type=template&id=4113e70e"
import script from "./OpenaiWebSearch.vue?vue&type=script&lang=js"
export * from "./OpenaiWebSearch.vue?vue&type=script&lang=js"
import style0 from "./OpenaiWebSearch.vue?vue&type=style&index=0&id=4113e70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports